<template>
  <div>
    <div class="hidden-sm-and-down">
      <div class="seccion">
        <div class="texto_" data-aos="fade-right">
          <el-row
            ><el-col class="padding-hr"> <hr style="width: 45px; height: 0.5px; background-color: #727272; margin: 0px" /></el-col
          ></el-row>

          <h2 class="servicio_text">{{ $t('servicio1.titulo') }}</h2>

          <p class="servicio_text" style="font-family: 'roboto-regular'" v-html="$t('servicio1.texto')"></p>
        </div>
        <!-- <div class="imagen parallax-inner">
          <img class="imagen parallax-inner" src="@/assets/fotos/01_ALMACENAMIENTO_2.jpg" alt="" />
        </div> -->
        <div class="parallax"></div>

        <div class="imagen" v-parallax="0.5">
          <div class="parallax"></div>
        </div>
      </div>

      <div class="seccion invertida">
        <div class="texto_" data-aos="fade-right">
          <el-row
            ><el-col class="padding-hr"> <hr style="width: 45px; height: 0.5px; background-color: #727272; margin: 0px" /></el-col
          ></el-row>

          <h2 class="servicio_text">{{ $t('servicio2.titulo') }}</h2>

          <p class="servicio_text" style="font-family: 'roboto-regular'" v-html="$t('servicio2.texto')"></p>
        </div>
        <div class="parallax"></div>

        <div class="imagen" v-parallax="0.5">
          <div class="parallax2"></div>
        </div>
        <!-- <div class="imagen" v-parallax="0.08">
          <img class="ondastop" src="@/assets/fotos/02_DISTRIBUCION_2.jpg" alt="" />
        </div> -->
      </div>
    </div>

    <div class="hidden-md-and-up">
      <el-row>
        <div class="texto_ servicio_text" data-aos="fade-right">
          <el-row
            ><el-col style="padding: 0% 0% 5% 0%"> <hr style="width: 45px; height: 0.5px; background-color: #727272; margin: 0px" /></el-col
          ></el-row>
          <h2 class="">{{ $t('servicio1.titulo') }}</h2>

          <p class="" style="font-family: 'roboto-regular'" v-html="$t('servicio1.texto')"></p>
        </div>
      </el-row>
      <el-row>
        <div class="imagen">
          <img class="ondastop" src="@/assets/fotos/01_ALMACENAMIENTO_2.jpg" alt="" />
        </div>
      </el-row>
      <el-row>
        <div>
          <div class="texto_ servicio_text" data-aos="fade-right">
            <el-row
              ><el-col style="padding: 0% 0% 5% 0%"> <hr style="width: 45px; height: 0.5px; background-color: #727272; margin: 0px" /></el-col
            ></el-row>

            <h2 class="">{{ $t('servicio2.titulo') }}</h2>

            <p class="" style="font-family: 'roboto-regular'" v-html="$t('servicio2.texto')"></p>
          </div>
        </div>
      </el-row>
      <el-row>
        <div class="imagen">
          <img class="ondastop" src="@/assets/fotos/02_DISTRIBUCION_2.jpg" alt="" /></div
      ></el-row>
    </div>
  </div>
</template>

<script>
import AOS from 'aos'
import 'aos/dist/aos.css'
export default {
  mounted() {
    AOS.init({
      duration: 1000, // velocidad de la animación (ms)
      offset: 100, // distancia antes de activar
      once: false, // si lo ponés en true solo se anima 1 vez
    })
  },
}
</script>
<style>
.parallax {
  /* The image used */
  background-image: url('~@/assets/fotos/01.jpg');

  /* Full height */
  height: 100%;

  /* Create the parallax scrolling effect */
  background-attachment: scroll;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.parallax2 {
  /* The image used */
  background-image: url('~@/assets/fotos/02_DISTRIBUCION.jpg');

  /* Full height */
  height: 100%;

  /* Create the parallax scrolling effect */
  background-attachment: scroll;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
/* PRUEBA */
.p-one {
  object-fit: cover;
  display: block;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('~@/assets/fotos/01.jpg');
  /* url('https://s-media-cache-ak0.pinimg.com/originals/27/05/74/2705741f272606db11ac1ae9938f2e93.jpg'); */
}
.p-two {
  object-fit: cover;
  display: block;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('~@/assets/fotos/02.jpg');
  /* url('https://s-media-cache-ak0.pinimg.com/originals/27/05/74/2705741f272606db11ac1ae9938f2e93.jpg'); */
}
.parallax-inner {
  position: relative;
  min-height: 600px;
  background-position: top center;
  background-attachment: fixed;
  background-size: cover;
}
.parallax-inner > h2 {
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 10px;
  position: absolute;
  top: 50%;
  left: 0;
  margin-top: -20.5px;
  width: 100%;
  text-align: center;
}
section {
  background-size: cover;
  color: white;
  background-color: var(--bg, --color-black);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
section.image2 {
  background-position: center center;
  transform: translateZ(-1px) scale(1.5);
  /* Force the background image to fill the whole element. */
  background-size: cover;
  /* Keep the image from overlapping sibling elements. */
  z-index: -1;
  height: 100vh;
}
/* --------- */
.bg-nosotros {
  padding: 5px 10% 10px 10%;
}
</style>
<style lang="scss" scoped>
@keyframes move-forever {
  0% {
    transform: translate3d(-90px, 0, 0);
  }
  100% {
    transform: translate3d(85px, 0, 0);
  }
}

.seccion {
  display: flex;
  min-height: 400px; /* alto mínimo */
  height: 500px;
  overflow: hidden; /* 🚫 que no muestre el espacio extra del parallax */
}

.texto_ {
  flex: 2; /* cada uno ocupa 50% */
  // height: 140% !important;
}
.imagen {
  flex: 2; /* cada uno ocupa 50% */
  height: 140% !important;
}

.texto_ {
  display: flex;
  flex-direction: column;
  justify-content: center; /* centra verticalmente el texto */
  // padding: 40px;
  text-align: justify;
  hyphens: auto;
  color: #727272;
  font-family: 'roboto-regular'; // text-align: left;
}

.texto_ h2 {
  // margin-bottom: 15px;
  margin-bottom: 0px;
  margin-top: 0px;
  // font-size: 1.5rem;
  font-size: 39px;
}

.texto_ p {
  // font-size: 1rem;
  font-size: 26px;
  line-height: 1.5;
  // font-weight: 700;
  margin-right: 10%;
  text-align: left;
}

.imagen {
  // overflow: hidden; /* recorta exceso de imagen */
}

.imagen img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* la imagen ocupa todo el espacio sin deformarse */
  display: block;
}

/* sección invertida: imagen primero */
.invertida {
  flex-direction: row-reverse;
  overflow: hidden; /* 🚫 que no muestre el espacio extra del parallax */
}
.padding-hr {
  padding: 0% 0% 5% 20%;
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  .seccion {
    display: flex;
    min-height: 400px; /* alto mínimo */
    height: 520px;
  }
  .servicio_text {
    padding: 0px 20% 0px 20%;
    font-family: 'roboto-black';
  }
  .padding-hr {
    padding: 0% 0% 5% 20%;
  }
  .texto_ h2 {
    font-size: 38px;
    margin: 0px;
    margin-bottom: 20px;
  }
  .texto_ p {
    font-size: 26px;
    margin: 0px;
    margin-right: 15% !important;
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .seccion {
    display: flex;
    min-height: 400px; /* alto mínimo */
    height: 520px;
  }
  .servicio_text {
    padding: 0px 20% 0px 20%;
    font-family: 'roboto-black';
  }
  .padding-hr {
    padding: 0% 0% 5% 20%;
  }
  .texto_ h2 {
    font-size: 34px;
  }
  .texto_ p {
    font-size: 23px;
    margin-right: 10% !important;
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .seccion {
    display: flex;
    min-height: 400px; /* alto mínimo */
    height: 450px;
  }
  .servicio_text {
    padding: 0px 21% 0px 21%;
    font-family: 'roboto-black';
  }
  .padding-hr {
    padding: 0% 0% 5% 21%;
  }
  .texto_ h2 {
    font-size: 30px;
  }
  .texto_ p {
    font-size: 21px;
    margin-right: 10% !important;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .seccion {
    display: flex;
    min-height: 400px; /* alto mínimo */
    height: 500px;
  }
  .servicio_text {
    padding: 10% 20% 10% 20%;
    font-family: 'roboto-black';
  }
  .texto_ h2 {
    font-size: 25px;
  }
  .texto_ p {
    font-size: 19px;
  }
  .imagen img[data-v-21e4adce] {
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    display: block;
    height: 400px;
  }
}
@media (orientation: landscape) and (max-height: 450px) {
  .servicio_text {
    padding: 10% 10% 10% 10%;
    font-family: 'roboto-black';
  }
}

@media screen and (min-width: 375px) and (max-width: 767px) {
  .seccion {
    display: flex;
    min-height: 400px; /* alto mínimo */
    height: 500px;
  }
  .servicio_text {
    padding: 12% 10% 12% 10%;
    font-family: 'roboto-black';
  }
  .texto_ h2 {
    font-size: 22px;
  }
  .texto_ p {
    font-size: 18px;
  }
  .imagen {
    flex: 2; /* cada uno ocupa 50% */
    height: 100% !important;
  }
}
@media (max-width: 375px) {
  .seccion {
    display: flex;
    min-height: 400px; /* alto mínimo */
    height: 500px;
  }
  .servicio_text {
    padding: 12% 10% 12% 10%;
    font-family: 'roboto-black';
  }
  .texto_ h2 {
    font-size: 22px;
  }
  .texto_ p {
    font-size: 18px;
  }
  .imagen {
    flex: 2; /* cada uno ocupa 50% */
    height: 100% !important;
  }
}
</style>
